import React from "react";

interface Props {
  value: string
}

// Turns "https://www.google.com/test" into "google.com"
const extractDomainAndExt = (url: string): string => {
  try {
    const parsedUrl = new URL(url);
    let domain = parsedUrl.hostname;

    if (domain.startsWith("www.")) {
      domain = domain.substring(4);
    }

    return domain;
  } catch {
    return url;
  }
};

const ReadonlyWebsite = ({ value }: Props) => {
  return <a href={value} target="_blank" rel="noreferrer">
    {extractDomainAndExt(value)}
  </a>;
};

export default ReadonlyWebsite;